// @ts-ignore
import formatDate_legacy, {formatRelative as formatRelative_legacy, formatDateByTimeZone as formatDateByTimeZone_legacy} from "@cirrus/legacy/app-common/alt/framework/formatDate.es6";

export const formatDate = (dt: any, format: string): string => {
  return formatDate_legacy(dt, format)
}

export const formatRelative = (dt: any): string => {
  return formatRelative_legacy(dt)
}

export const formatDateByTimeZone = (dt: any, format: string): string => {
  return formatDateByTimeZone_legacy(dt, format)
}

